module.exports = __webpack_public_path__ + "img/zain-businees.8adce681.png";